/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit"
import { asBoolean } from "../commons/utils"
import httpClient from "./httpClient"

const initialState = {
  disabled: false
}

const esignSlice = createSlice({
  initialState,
  name: "esign",
  reducers: {
    setDisabled: (state, { payload }) => {
      state.disabled = asBoolean(payload)
    }
  }
})

function fetchEsignConfig(cancelToken) {
  return async (dispatch) => {
    const { data } = await httpClient.get("/api/config/docusign", {
      cancelToken
    })
    const { docusign } = data
    if (docusign?.noConfig?.value != null) {
      dispatch(esignSlice.actions.setDisabled(docusign.noConfig.value))
    }
  }
}

export default {
  initialState,
  actions: {
    ...esignSlice.actions,
    fetchEsignConfig
  },
  reducer: esignSlice.reducer
}
